import React, { FC } from 'react'
import { Link } from 'react-router-dom'
import { Box, Button, CircularProgress, IconButton, Tooltip } from '@mui/material'
import AddIcon from '@mui/icons-material/Add'
import CachedIcon from '@mui/icons-material/Cached'
import QuestionAnswerIcon from '@mui/icons-material/QuestionAnswer'
import { ITicketQueryParam } from '@shared/Services/QueryParamService'
import { ModalRoute } from '@lib/Layout/ModalRoute'

interface IProps {
  loading?: boolean
  onClick?: () => void
}

export const BtnRefresh: FC<IProps> = (p) => (
  <Box sx={{ width: '100%', display: 'flex', justifyContent: 'flex-end', alignItems: 'center', my: '-6px' }}>
    <Tooltip title='Refresh'>
      <IconButton onClick={!p.loading ? p.onClick : undefined}>{p.loading === true ? <CircularProgress size='24px' /> : <CachedIcon />}</IconButton>
    </Tooltip>
  </Box>
)

interface IBtnConversationProps {
  routeKey: string
  query: ITicketQueryParam
}

export const BtnConversation: FC<IBtnConversationProps> = (props) => (
  <IconButton color='info' onClick={() => ModalRoute.show({ routeKey: props.routeKey, query: props.query })}>
    <QuestionAnswerIcon />
  </IconButton>
)

export const BtnCreate: FC<{ to: string }> = (props) => (
  <Button size='small' variant='contained' startIcon={<AddIcon />} component={Link} to={props.to}>
    Create
  </Button>
)
